import type { GovTabsProps } from '@gov-design-system-ce/react';
import type { PPPSeznamFilterType } from '../filter/seznamFilter.types';

export enum PPPTypeTabs {
	AKTUALNI = 'AKTUALNI',
	HISTORIE = 'HISTORIE',
}

export enum PPPStatusTabs {
	VSE = 'VSE',
	PRIJATO = 'PRIJATO',
	SCHVALENO = 'SCHVALENO',
	ODESLANO_K_DOPRACOVANI = 'ODESLANO_K_DOPRACOVANI',
	ODESLANO_SPRAVCI = 'ODESLANO_SPRAVCI',
	ZAMITNUTO = 'ZAMITNUTO',
	UKONCENO = 'UKONCENO',
}

export type PPPTypeTab = keyof typeof PPPTypeTabs;
export type PPPStatusTab = keyof typeof PPPStatusTabs;
export type PPPStatusByType = Record<PPPTypeTab, PPPStatusTab>;
export type PPPDatesByType = Record<
	PPPTypeTab,
	Pick<PPPSeznamFilterType, 'datumOd' | 'datumDo'>
>;

type Tabs<T extends string> = {
	activeTab: T;
	items: GovTabsProps['items'];
	onTabChange: (identifier: string, index: number) => void;
};

export interface PPPSeznamTabsReturnType {
	pppTypeTabs: Tabs<PPPTypeTab>;
	pppStatusTabs: Tabs<PPPStatusTab>;
}
